import { ROUTING } from '../config/routing.js';
export function announcementFor(route, progress, zuletztGesagt) {
    const manöver = route.maneuvers[progress.maneuverIndex];
    if (manöver === undefined) {
        return null;
    }
    /*
     * Das Ziel wird nicht angesagt.
     *
     * Es ist das nächste Manöver, sobald keine Abbiegung mehr dazwischenliegt —
     * auf gerader Strecke schon einen Kilometer vorher. Angesagt hätte die App
     * dann bei vierhundert Metern „Weiter bis zur Kolonne", und der Fahrer hätte
     * eine Anweisung gehört, wo es nichts zu tun gibt.
     *
     * Die Ankunft meldet, wer sie feststellt: das Ende der Navigation,
     * unterhalb von `ROUTING.arrivalDistanceM`. Ein Satz, ein Augenblick.
     */
    if (manöver.kind === 'destination') {
        return null;
    }
    const satz = manöver.verbal ?? manöver.instruction;
    const stufe = progress.distanceToManeuverM <= ROUTING.announceNearM
        ? 'near'
        : progress.distanceToManeuverM <= ROUTING.announceFarM
            ? 'far'
            : null;
    if (stufe === null) {
        return null;
    }
    const key = `${stufe}|${satz}`;
    if (key === zuletztGesagt) {
        return null;
    }
    return {
        key,
        stage: stufe,
        text: stufe === 'near'
            ? satz
            : `In ${formatDistanceM(progress.distanceToManeuverM)}: ${satz}`,
    };
}
/**
 * Eine Entfernung, wie ein Mensch sie sagt.
 *
 * Nicht „In 287 Metern" — kein Fahrer misst das nach, und die Genauigkeit
 * täuscht eine vor, die GPS gar nicht hat. Gerundet wird gröber, je weiter es
 * ist.
 */
export function formatDistanceM(meter) {
    if (meter < 20) {
        return 'jetzt';
    }
    if (meter < 100) {
        return `${String(Math.round(meter / 10) * 10)} Metern`;
    }
    if (meter < 1_000) {
        return `${String(Math.round(meter / 50) * 50)} Metern`;
    }
    const km = meter / 1_000;
    return `${km.toFixed(km < 10 ? 1 : 0).replace('.', ',')} Kilometern`;
}
/** Dieselbe Entfernung als kurze Angabe für den Bildschirm: „300 m", „2,4 km". */
export function shortDistanceM(meter) {
    if (meter < 100) {
        return `${String(Math.round(meter / 10) * 10)} m`;
    }
    if (meter < 1_000) {
        return `${String(Math.round(meter / 50) * 50)} m`;
    }
    const km = meter / 1_000;
    return `${km.toFixed(km < 10 ? 1 : 0).replace('.', ',')} km`;
}
//# sourceMappingURL=announce.js.map